<template>
  <el-header class="container-header m-header" style="flex-wrap: wrap">
    <div class="tag">
      <div class="label">
        模板分类
        <span>|</span>
      </div>
      <div class="content">
        <span class="item" @click="choseTag(null, null, null)" :class="{'active': pickedTagIndex === -1}">全部</span>
        <span class="item"
              @click="choseTag(item.id, index, item.name)"
              v-for="(item, index) in tagsList"
              :key="index"
              :class="{'active': pickedTagIndex === index}">{{typeNameMap[item.name] || item.name}}
                          <i @click.stop="onDelTag(item, index)" class="el-icon-close del-tag" v-if="item.id"></i>
                      </span>
      </div>
    </div>
    <div class="condition-item">
      <div class="label">
        模板版权
        <span>|</span>
      </div>
      <div class="content">
        <span class="item" @click="chooseCopyRight(null)" :class="{'active': param.canCommercial === null}">全部</span>
        <span class="item" :class="{'active': param.canCommercial}" @click="chooseCopyRight(true)">可商用</span>
        <span class="item" :class="{'active': param.canCommercial === false}"
              @click="chooseCopyRight(false)">不可商用</span>
      </div>
    </div>
    <div class="condition-item">
      <div class="label">
        模板类型
        <span>|</span>
      </div>
      <div class="content">
        <span class="item" @click="chooseFree(null)" :class="{'active': param.free === null}">全部</span>
        <span class="item" :class="{'active': param.free}" @click="chooseFree(true)">自由模板</span>
        <span class="item" :class="{'active': param.free === false}"
              @click="chooseFree(false)">固定模板</span>
      </div>
    </div>
    <div class="left">
      <el-checkbox v-model="checkAll" @change="toggleCheckAll">全选</el-checkbox>
      <el-dropdown trigger="click" @command="exportImgs">
        <el-button type="primary" style="margin-right: 10px;" :disabled="!selectList.length" round>导出<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="png">PNG</el-dropdown-item>
          <el-dropdown-item command="jpg">JPG</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-popover popper-class="c-delete-propper" v-model="visible1">
        <p><i class="el-icon-warning"></i>你确认要删除这些作品吗？</p>
        <div style="text-align: right; margin: 0">
          <el-button @click="visible1=false">取消</el-button>
          <el-button type="primary" @click="visible1=false; deleteWorks()">确定</el-button>
        </div>
        <el-button :loading="loading" slot="reference" class="header-del" :disabled="!selectList.length" round>删除
        </el-button>
      </el-popover>
    </div>
    <div class="right">
      <div class="tag-box">
        <label class="item-title">作品标签 </label>
        <el-select
          @change="submitSearch"
          v-model="param.workTagIds"
          multiple
          collapse-tags
          placeholder="请选择标签"
          no-data-text="暂无标签"
        >
          <el-option
              v-for="item in workTagOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </div>
      <!-- <div class="size-box">
        <label class="item-title">作品尺寸 </label>
        <el-select @change="submitSearch" v-model="param.widthHeights" multiple placeholder="请选择尺寸">
          <el-option
              v-for="item in sizeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="time-box">
        <label class="item-title">更新时间 </label>
        <el-select @change="submitSearch" v-model="param.searchTime" placeholder="全部时间">
          <el-option
              v-for="item in searchOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div> -->
      <div class="search-box">
        <el-input v-model="param.name" @change="submitSearch" placeholder="按作品名称搜索"></el-input>
        <el-button class="search-btn" type="primary" @click="submitSearch" circle
                   icon="iconfont icon-search"></el-button>
      </div>
    </div>
  </el-header>
</template>
<script>
    import worksService from '../../../request/service/works-service'
    import templateService from '../../../request/service/template-service'
    import {template_type_mapping} from '@/const.js'

    export default {
        props: {
            selectList: {
                type: Array, default: () => {
                    return [];
                }
            },
            condition: Object,
            projectId: String,
            loading: Boolean,
        },
        data() {
            return {
                checkAll: false,
                visible1: false,
                workTagOptions: [],
                searchOptions: [{
                    label: '最近一周',
                    value: '1',
                }, {
                    label: '最近一个月',
                    value: '2',
                }, {
                    label: '最近三个月',
                    value: '3',
                }, {
                    label: '最近半年',
                    value: '4',
                }, {
                    label: '最近一年',
                    value: '5',
                }, {
                    label: '全部时间',
                    value: '6',
                }],
                sizeOptions: [],
                param: {
                    name: this.condition.name,
                    searchTime: this.condition.searchTime,
                    widthHeights: this.condition.widthHeights,
                    type: null,
                    tagIds: [],
                    workTagIds: [],
                    canCommercial: null,
                    free: null
                },
                pickedTagIndex: -1,
                typeNameMap: template_type_mapping
            }
        },
        computed: {
            tagsList() {
                return this.$store.state.app.templateIndexTags;
            },
        },
        watch: {
            projectId() {
                this.getWorksSize();
                this.getWorkTags();
            }
        },
        created() {
            this.getWorksSize();
            this.getWorkTags()
        },
        methods: {
            getWorksSize() {
                worksService.getWorksSize(this.projectId).then((data) => {
                    let options = [];
                    data.forEach(size => {
                        options.push({label: size, value: size})
                    });
                    this.sizeOptions = options;
                });
            },
            getWorkTags() {
              worksService.getWorkTagList(this.projectId).then((data) => {
                this.workTagOptions = data
              })
            },
            toggleCheckAll(val) {
                this.$emit('toggleCheckAll', val);
            },
            exportImgs(fileType) {
                this.$emit('exportImgs', fileType);
            },
            deleteWorks() {
                this.$emit('deleteWorks');
            },
            submitSearch() {
                this.$emit('submitSearch', this.param);
            },
            reset() {
                this.param.name = '';
                this.param.searchTime = '';
                this.param.widthHeights = [];
            },
            checkedAll() {
                this.checkAll = true;
            },
            uncheckedAll() {
                this.checkAll = false;
            },
            choseTag(id, index, name) {
                if (index !== null) {
                    this.pickedTagIndex = index;
                } else {
                    this.pickedTagIndex = -1;
                }
                this.queryByTag(id, index, name);
            },
            queryByTag(id, index, name) {
                this.param.pageNum = 1;
                this.param.pageSize = 30;
                if (id) {
                    this.param.tagIds = [id];
                } else {
                    this.param.tagIds = [];
                }
                // 图文和团队两个标签，用来过滤模板类型，tagIds 需为空
                let types = Object.keys(this.typeNameMap);
                if (types.includes(name)) {
                    this.param.type = name;
                    this.param.tagIds = [];
                } else {
                    this.param.type = null;
                }
                this.getData();
            },
            getData(){
                this.$emit('submitSearch', this.param);
            },
            onDelTag(item, index) {
                if (this.pickedTagIndex === index) {
                    this.choseTag(null, null, null);
                }
                templateService.delTemplateTag(item.id).then(() => {
                    let dataList = this.tagsList.filter((obj) => {
                        return obj.id !== item.id;
                    });
                    this.$store.commit('app/set_template_tags', dataList);
                    this.$message.success({
                        message: '操作成功',
                        duration: 1000
                    });
                });
            },
            chooseCopyRight(canCommercial){
                this.param.canCommercial = canCommercial;
                this.getData();
            },
            chooseFree(free){
                this.param.free = free;
                this.getData();
            }
        }
    }
</script>

